<template>
    <v-dialog v-model="dialog">
        <template #activator="{ on }">
            <slot name="activator" :on="on">
                <v-btn icon v-on="on">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </slot>
        </template>
        <v-card>
            <v-card-title>Tax Rate</v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-row>
                        <v-col>
                            <v-text-field label="Name" v-model="model.name" :rules="mandatoryRules" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field label="Rate" v-model="model.taxRate" :rules="mandatoryRules" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <CountryAutocomplete label="Country" v-model="model.country" :rules="mandatoryRules" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <TaxesSelect label="Bexio Tax" v-model="model.bexio_id" :rules="mandatoryRules" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="dialog=false">Cancel</v-btn>
                <v-spacer />
                <v-btn @click="save">Save</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import _ from "lodash"
import CountryAutocomplete from "@components/forms/autocomplete/Country.vue";
import TaxesSelect from "../bexio/form/TaxesSelect.vue";
import { mapActions } from "vuex";

export default {
    name:'TaxRateForm',
    components: { CountryAutocomplete, TaxesSelect },
    props:{
        rate: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        dialog:false,
        model: {},
        mandatoryRules: [v => !!v || "This fiels is mandatory"],
    }),
    watch: {
        dialog: function (v) {
            if(v && this.rate){
                this.model = _.cloneDeep(this.rate)
            } else {
                this.model = {}
            }
        }
    },
    methods: {
        ...mapActions('taxRates', {addTaxRate: 'add', updateTaxRate: 'update'}),
        save () {
            if(this.$refs.form.validate()){
                let query = null
                if(this.model.id) {
                    query = this.updateTaxRate(this.model)
                }else{
                    query = this.addTaxRate(this.model)
                }
                query.then(({tax_rate}) => {
                    if(tax_rate){
                        this.dialog = false
                        this.$emit('change')
                    }
                }).catch(({data}) => {
                    for(let error in data.errors) {
                        this.flashMessage.error({
                            message: `Error: ${data.errors[error].join(',')}`,
                        })    
                    }
                })
            }
        }
    }
}

</script>